// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"CustomStatisticalControlBatchDetail_actionsWrapper__1JIAn"};